/* Página de produto Navita — comportamento comum dos blocos navita-* da secção principal.
   1. Ao mudar de variante, o Dwell recebe a secção inteira já desenhada para a nova variante (evento
      shopify:product:select). Copiamos daí os elementos [data-navita-atualiza] (preço, metros, stock…).
   2. Total no botão "Adicionar ao carrinho" (preço × quantidade).
   3. Prazo de envio: "sai hoje" / "sai amanhã" / "sai segunda-feira", pela hora de Lisboa e a hora limite.
   4. Barra do envio grátis (carrinho + este produto + extras escolhidos no bloco "Completa o projeto"). */
(() => {
  if (window.NavitaProduto) return;
  const N = (window.NavitaProduto = {});
  const lingua = document.documentElement.lang || 'pt-PT';
  const es = lingua.startsWith('es');
  const en = lingua.startsWith('en');
  N.dinheiro = (centimos, moeda) =>
    new Intl.NumberFormat(lingua, { style: 'currency', currency: moeda || window.Shopify?.currency?.active || 'EUR' }).format(centimos / 100);

  const form = () => document.querySelector('.product-information form[action*="/cart/add"]');
  const precoUnit = () => Number(document.querySelector('[data-navita-preco]')?.dataset.navitaPreco) || 0;
  const quantidade = () => Math.max(1, Number(form()?.querySelector('[name="quantity"]')?.value) || 1);
  N.extras = 0;
  N.par = 0; // 2.º kit da campanha "2 kits" (assets/navita-campanha.js), já com o desconto
  N.parTexto = '';

  /* 1. Atualizar blocos depois de mudar de variante */
  document.addEventListener('shopify:product:select', (e) => {
    if (e.target?.closest?.('product-card')) return;
    e.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;
        for (const vivo of document.querySelectorAll('[data-navita-atualiza]')) {
          const novo = detail.html.querySelector(`[data-navita-atualiza="${vivo.dataset.navitaAtualiza}"]`);
          if (novo) {
            vivo.innerHTML = novo.innerHTML;
            for (const a of novo.getAttributeNames()) vivo.setAttribute(a, novo.getAttribute(a));
          }
        }
        atualizarTudo();
      })
      .catch(() => {});
  });

  /* 2. Total no botão de compra */
  // texto do botão: com a campanha "2 kits" passa a "Adicionar os 2 kits"; volta ao original sem ela
  function textoDoBotao(b) {
    const no = [...(b.querySelector('.add-to-cart-text') || b).childNodes].find((x) => x.nodeType === 3 && x.textContent.trim());
    if (!no) return;
    if (b.dataset.navitaTexto === undefined) b.dataset.navitaTexto = no.textContent.trim();
    const novo = N.parTexto || b.dataset.navitaTexto;
    if (no.textContent.trim() !== novo) no.textContent = novo;
  }
  function totalNoBotao() {
    const total = precoUnit() * quantidade() + (N.par || 0);
    for (const b of document.querySelectorAll('.product-information .add-to-cart-button')) {
      textoDoBotao(b);
      let s = b.querySelector('.navita-total');
      if (!s) {
        s = document.createElement('span');
        s.className = 'navita-total';
        (b.querySelector('.add-to-cart-text') || b).appendChild(s);
      }
      s.textContent = total ? N.dinheiro(total) : '';
    }
  }

  /* 3. Prazo de envio (dias úteis; feriados não contam) */
  function prazo() {
    for (const el of document.querySelectorAll('[data-navita-prazo]')) {
      const limite = Number(el.dataset.navitaPrazo) || 13;
      const agora = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Lisbon' }));
      const dia = agora.getDay(); // 0 domingo … 6 sábado
      const util = dia >= 1 && dia <= 5;
      let txt;
      if (util && agora.getHours() < limite) txt = es ? 'sale hoy' : en ? 'it ships today' : 'sai hoje';
      else if (dia >= 1 && dia <= 4) txt = es ? 'sale mañana' : en ? 'it ships tomorrow' : 'sai amanhã';
      else txt = es ? 'sale el lunes' : en ? 'it ships on Monday' : 'sai segunda-feira';
      const alvo = el.querySelector('[data-navita-prazo-txt]');
      if (alvo) alvo.textContent = txt;
    }
  }

  /* 4. Barra do envio grátis */
  N.carrinho = null;
  async function lerCarrinho() {
    try {
      const c = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      N.carrinho = c.total_price;
    } catch (e) { N.carrinho = 0; }
    envio();
  }
  function envio() {
    for (const el of document.querySelectorAll('[data-navita-envio]')) {
      const limite = Number(el.dataset.navitaEnvio) || 0;
      if (!limite) continue;
      const casa = Number(el.dataset.navitaEnvioCasa) || 0; // 2.ª meta (em casa); 0 = só uma
      const topo = casa > limite ? casa : limite;
      const soma = (N.carrinho || 0) + precoUnit() * quantidade() + N.extras + (N.par || 0);
      const falta = Math.max(0, limite - soma);
      const faltaCasa = casa > limite ? Math.max(0, casa - soma) : 0;
      const pct = Math.min(100, (soma / topo) * 100);
      el.classList.toggle('is-gratis', falta === 0 && faltaCasa === 0);
      const txt = el.querySelector('[data-navita-envio-txt]');
      const jaTinha = (N.carrinho || 0) >= topo;
      if (txt) txt.innerHTML = falta
        ? (el.dataset.txtFalta || '').replace('[valor]', `<b>${N.dinheiro(falta)}</b>`)
        : faltaCasa
          ? `✓ ${(el.dataset.txtMeio || '').replace('[valor]', `<b>${N.dinheiro(faltaCasa)}</b>`)}`
          : `✓ <b>${(jaTinha ? el.dataset.txtGratis : el.dataset.txtCom || el.dataset.txtGratis) || ''}</b>`;
      el.querySelector('[data-navita-meta="1"]')?.classList.toggle('is-ok', falta === 0);
      el.querySelector('[data-navita-meta="2"]')?.classList.toggle('is-ok', casa > limite && faltaCasa === 0);
      el.querySelector('[data-navita-barra]')?.style.setProperty('--np-pct', pct + '%');
    }
  }
  N.envio = envio;
  N.lerCarrinho = lerCarrinho;

  /* Navita Points × quantidade */
  function pontos() {
    for (const el of document.querySelectorAll('[data-navita-pontos]')) {
      el.textContent = Math.floor(Number(el.dataset.navitaPontos) * (quantidade() + (N.par || 0) / (precoUnit() || 1)));
    }
  }

  function atualizarTudo() {
    totalNoBotao();
    prazo();
    pontos();
    envio();
  }
  N.atualizar = atualizarTudo;

  // a quantidade muda por botões (+/−) ou à mão; o botão de compra é redesenhado pelo tema → voltar a pôr o total
  document.addEventListener('click', (e) => { if (e.target.closest('.product-information')) setTimeout(atualizarTudo, 60); });
  document.addEventListener('change', (e) => { if (e.target.closest('.product-information')) setTimeout(atualizarTudo, 60); });
  document.addEventListener('input', (e) => { if (e.target.matches?.('[name="quantity"]')) atualizarTudo(); });
  new MutationObserver(() => {
    if ([...document.querySelectorAll('.product-information .add-to-cart-button')].some((b) => !b.querySelector('.navita-total'))) totalNoBotao();
  }).observe(document.querySelector('.product-information') || document.body, { childList: true, subtree: true });
  // depois de juntar ao carrinho, o envio grátis muda
  document.addEventListener('shopify:cart:lines-update', () => setTimeout(lerCarrinho, 1500));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { atualizarTudo(); lerCarrinho(); });
  else { atualizarTudo(); lerCarrinho(); }
  setInterval(prazo, 60000);
})();
